export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8018.8d8e9151.jpg";